export const WaitMessage = () => {
  return (
    <>
      <div>
        <p>
          Uploading data. Depending on your filesize, this operation can take up
          to 2 minutes.
        </p>
      </div>
    </>
  );
};
